import { StackProps, TypographyProps } from '@mui/material';
import React, { ReactNode } from 'react';
import { useAccount } from 'wagmi';

import { Actions } from 'src/global/constants/role.constant';

interface ActionGuardProps {
  action: Actions;
  message?: string;
  stackProps?: Omit<StackProps, 'children'>;
  typographyProps?: Omit<TypographyProps, 'children'>;
  children: ReactNode;
}

const ActionGuard: React.FC<ActionGuardProps> = ({ children }) => {
  const { address } = useAccount();
  if (!address) return null;

  return <>{children}</>;
};

export default ActionGuard;
